import React from 'react';
import { Link } from 'react-router-dom';
import api, { setCustomerSession } from '../api/client';
import withRouter from '../withRouter';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: '', password: '', error: null, submitting: false };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    this.setState({ submitting: true, error: null });

    api.login(email, password)
      .then(({ token, customer }) => {
        setCustomerSession(token, customer);
        this.props.onLogin(customer);
        this.props.navigate('/');
      })
      .catch((err) => {
        this.setState({ submitting: false, error: err.response?.data?.error || 'Login failed' });
      });
  };

  render() {
    const { email, password, error, submitting } = this.state;
    return (
      <div className="auth-page">
        <h1>Log in</h1>
        <form onSubmit={this.handleSubmit}>
          <label>
            Email
            <input type="email" required value={email} onChange={(e) => this.setState({ email: e.target.value })} />
          </label>
          <label>
            Password
            <input type="password" required value={password} onChange={(e) => this.setState({ password: e.target.value })} />
          </label>
          {error && <p className="error">{error}</p>}
          <button className="btn btn-primary" type="submit" disabled={submitting}>
            {submitting ? 'Signing in...' : 'Log in'}
          </button>
        </form>
        <p className="auth-switch">Don't have an account? <Link to="/signup">Sign up</Link></p>
      </div>
    );
  }
}

export default withRouter(LoginPage);
